import { DragulaService } from 'ng2-dragula';
import { Directive, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';

// Use this directive with ng2-dragula library to add autoScroll on drag'n'drop events
@Directive({
	selector: '[dnd-auto-scroll]'
})
export class DndAutoScroll implements OnInit, OnDestroy {
	scrollable = true;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(private dragulaService: DragulaService) {}

	private static addMoveListeners(): void {
		document.addEventListener('mousemove', DndAutoScroll.mouseMoveListener);
		document.addEventListener('touchmove', DndAutoScroll.touchMoveListener);
	}

	private static removeListeners(): void {
		document.removeEventListener('mousemove', DndAutoScroll.mouseMoveListener);
		document.removeEventListener('touchmove', DndAutoScroll.touchMoveListener);
	}

	private static mouseMoveListener(e): void {
		const pageY = 'pageY';
		const mouseY = e.pageY || window.event[pageY];
		const scrollTop = document.documentElement.scrollTop
			? document.documentElement.scrollTop
			: document.body.scrollTop; // document.documentElement.scrollTop is undefined on the Edge browser
		const scrollBottom = scrollTop + window.innerHeight;

		if (mouseY - 100 < scrollTop) {
			window.scrollBy(0, -15);
		} else if (mouseY + 100 > scrollBottom) {
			window.scrollBy(0, 15);
		}
	}

	private static touchMoveListener(e): void {
		const { clientY } = e.touches[0];

		if (clientY - 100 < 0) {
			window.scrollBy(0, -20);
		} else if (clientY + 100 > window.innerHeight) {
			window.scrollBy(0, 20);
		}
	}

	ngOnInit(): void {
		this.addDragulaEventsListeners();
	}

	ngOnDestroy(): void {
		this.clear();
	}

	private removeDefaultScrollOnTouch = (e): void => {
		if (!this.scrollable) {
			e.preventDefault();
		}
	};

	private addDragulaEventsListeners(): void {
		document.addEventListener('touchmove', this.removeDefaultScrollOnTouch, {
			passive: false
		});
		this.dragulaService.drag.takeUntil(this.unsubscribe).subscribe((): void => {
			this.scrollable = false;
			DndAutoScroll.addMoveListeners();
		});
		this.dragulaService.dragend
			.takeUntil(this.unsubscribe)
			.subscribe((): void => {
				this.scrollable = true;
				DndAutoScroll.removeListeners();
				document.onmousemove = null;
			});
	}

	private clear(): void {
		document.removeEventListener('touchmove', this.removeDefaultScrollOnTouch);
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/pipes/dnd-autoscroll/dnd-autoscroll.ts